import type { CopyShape } from "@tami/core/intl";

import type { WHATSAPP_SCRIPT_COPY_PT_BR } from "../whatsapp-script.copy";

export const WHATSAPP_SCRIPT_COPY_EN_US: CopyShape<typeof WHATSAPP_SCRIPT_COPY_PT_BR> = {
  whatsappIntro: {
    narrative:
      "Tãmi lives in your WhatsApp: she organizes your day, schedules content and tracks your numbers — all in the chat.",
  },
  whatsappAgenda: {
    narrative:
      "Every morning, Tãmi sends you your schedule, ready to go: the day's posts, events and due dates in one place.",
    callout: "Good morning with your schedule in hand — sent automatically, no need to ask.",
  },
  whatsappContent: {
    narrative: "Got an idea? Send it on WhatsApp. Tãmi creates the plan in the Content hub right away.",
    callout: "You describe it, Tãmi plans it: network, format and date already logged.",
  },
  whatsappEvent: {
    narrative: "Need to book a shoot or a meeting? She adds it straight to your calendar and reminds you on the day.",
    callout: "Calendar events created from the chat, with a reminder guaranteed.",
  },
  whatsappPerformance: {
    narrative:
      "And at the end of the week, your performance recap arrives: engagement, posts and followers, compared with the week before.",
    callout: "Automatic weekly recap — your numbers land on WhatsApp already broken down.",
  },
  whatsappOutro: {
    narrative: "From the morning schedule to the weekly recap: Tãmi handles the routine while you focus on creating.",
  },
};
